import { CR_PROVINCES, SELECT_INPUT_TYPE } from "utils/Constants";

export default {
    province:{
        "type": SELECT_INPUT_TYPE,
        "name": "province",
        "label": "Provincia",
        "options": CR_PROVINCES
    },
    canton:{
        "type": SELECT_INPUT_TYPE,
        "name": "canton",
        "label": "Canton",
        "options": []
    },
    district:{
        "type": SELECT_INPUT_TYPE,
        "name": "district",
        "label": "Distrito",
        "options": []
    },
}